const $ = require('jquery')
window.$ = window.jQuery = $;

require('popper.js');
require('bootstrap');

require("ekko-lightbox");
require("svgxuse");
require("jquery-hoverintent");

require("tocca"); // touch events

require("../../default/js/polyfill/objectFitPolyfill.basic.js");
require("../../default/js/polyfill/jquery.inview.js");
require("../../default/js/carousel/slick.js");
require("../../default/js/carousel/slick-lightbox.js");
require('../../default/js/superfish');

// require("./utilities/body-scroller");

require("./utilities/animate-svg");
require("./utilities/init");
require("./utilities/lazy");
require("./utilities/lightbox");
require("./utilities/popme");
require("./utilities/smooth-scrolling");
require("./utilities/sticky");
require("./utilities/tooltip");

require("./widget/toggle-click");
require("./widget/search");
require("./widget/carousel/hero");
require("./widget/carousel/slider");
require("./widget/carousel/slideshow");
require("./widget/navbar");
require("./widget/dataset-browse");
require("./widget/pdf-widget");
require("./widget/table-special");
require("./widget/newsletter"); // rename as widget

require('./pages')

// purposely last to ease conflict with lazy loading images
require("./utilities/animate-scroll");
